import { createVariables } from "./createVariables";
function createTokens(tokens) {
  return createVariables(tokens);
}
export {
  createTokens
};
